import React from 'react'

const CheckMark = ({ size = 'small', color, bgColor }) => {
    switch (size) {
        case 'small': {
            return (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="12" cy="12" r="12" fill={bgColor} />
                    <path
                        d="M7.875 11.2212L11.5893 15.375L16.875 8.625"
                        stroke={color}
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            )
        }
        case 'big': {
            return (
                <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        fill={bgColor}
                        d="M48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24Z"
                    />
                    <path
                        fill={color}
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M35.233 15.7546C36.1026 16.4291 36.2556 17.6742 35.5746 18.5356L25.0032 31.907C24.6382 32.3686 24.0855 32.6464 23.4938 32.6655C22.9021 32.6847 22.3323 32.4432 21.9377 32.0061L14.5091 23.7775C13.7729 22.962 13.8435 21.7097 14.6669 20.9804C15.4903 20.2512 16.7546 20.3211 17.4909 21.1367L23.3269 27.6012L32.4253 16.093C33.1063 15.2316 34.3633 15.0801 35.233 15.7546Z"
                    />
                </svg>
            )
        }
        case 'large': {
            return (
                <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        fill={bgColor}
                        d="M60 30C60 46.5685 46.5685 60 30 60C13.4315 60 0 46.5685 0 30C0 13.4315 13.4315 0 30 0C46.5685 0 60 13.4315 60 30Z"
                    />
                    <path
                        fill={color}
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M44.0412 19.6933C45.1283 20.5365 45.3195 22.0928 44.4682 23.1696L31.254 39.8838C30.7978 40.4608 30.1068 40.8081 29.3672 40.832C28.6276 40.8559 27.9153 40.554 27.4221 40.0076L18.1364 29.722C17.2161 28.7025 17.3044 27.1372 18.3336 26.2256C19.3629 25.314 20.9433 25.4015 21.8636 26.4209L29.1586 34.5015L40.5316 20.1163C41.3828 19.0396 42.9542 18.8502 44.0412 19.6933Z"
                    />
                </svg>
            )
        }
        default: {
            return null
        }
    }
}

export default CheckMark
